var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTest2019(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#FFEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 7.66406H8.33333C7.59695 7.66406 7 8.26102 7 8.9974V18.3307C7 19.0671 7.59695 19.6641 8.33333 19.6641H17.6667C18.403 19.6641 19 19.0671 19 18.3307V8.9974C19 8.26102 18.403 7.66406 17.6667 7.66406Z",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 6.33594V9.0026",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 6.33594V9.0026",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.6641H19",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest2019);
export default __webpack_public_path__ + "static/media/test_2019.c0f3d15ed2be85e56c02a91468a06ba4.svg";
export { ForwardRef as ReactComponent };